import axios from "axios";
import { API_BASE_URL } from "./apiConfig";

const accessToken = () => localStorage.getItem("access_token");

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use((config) => {
  config.headers.Authorization = `Bearer ${accessToken()}`;
  return config;
});

const axiosFormDataInstance = axios.create({
  baseURL: API_BASE_URL,
});

axiosFormDataInstance.interceptors.request.use((config) => {
  config.headers.Authorization = accessToken();
  return config;
});

export { axiosInstance, axiosFormDataInstance };
